// utils.js

import CryptoJS from 'crypto-js';

const mi = '#l_vle_ll_e%+$^@0608)['

export default {
	generateRandomAlphaString(length) {
		var result = '';
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	},
	ksort(obj) {
		var keys = Object.keys(obj).sort();
		var sortedObj = keys.reduce(function(sorted, key) {
			sorted[key] = obj[key];
			return sorted;
		}, {});
		return sortedObj;
	},
	objectToQueryString(obj) {
		return Object.entries(obj)
			.map(([key, val]) => `${encodeURIComponent(key)}=${decodeURIComponent(val)}`)
			.join('&');
	},
	sha1(message) {
		return CryptoJS.SHA1(message).toString();
	},
	generateSignature(data) {
		// 将数据和密钥进行字符串拼接
		const message = data + mi;
		// 使用CryptoJS的MD5方法生成MD5签名
		const md5Signature = CryptoJS.MD5(message).toString();
		return md5Signature;
	},
}


//////////////////
// WEBPACK FOOTER
// ./common/secretKey.js
// module id = n5sL
// module chunks = 20